import { forwardRef } from "react";
import { extendVariants, Button as ButtonNext } from "@nextui-org/react";

const ButtonVariant = extendVariants(ButtonNext, {
  variants: {
    color: {
      default: "h-8 min-w-44 text-base bg-gray-400 text-white hover:border-gray-300",
      primary: "h-8 min-w-44 text-base font-bold",
    },
  },
  defaultVariants: {
    color: "default",
  },
});

const Button = forwardRef(function Button(props, ref) {
  const { children, ...rest } = props;
  return (
    <ButtonVariant ref={ref} {...rest}>
      {children}
    </ButtonVariant>
  );
});

export default Button;